import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Api's
import { manufacturerApi } from "@/main/api";

// Redux
import { saveManufacturers, GetManufacturers } from "./index";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getManufacturersSaga(action: GetManufacturers) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			manufacturerApi.getVehicleManufacturer,
			action.payload.request,
		);
		if (response.data.result) {
			yield put(saveManufacturers(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveManufacturers(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
